import React from 'react'
import InfoContent from '../../components/organisms/InfoContent'
import Layout from '../../components/wrappers/Layout'
import HeroSection from '../../components/molecules/HeroSection'
import pageContent from './pageContent'
import useScrollToTop from '../../utils/scrollToTop'
import { pageTitles } from '../../router/routes'
import { Helmet } from 'react-helmet'

const TermsOfUsePage: React.FC = () => {
  useScrollToTop()
  return (
    <Layout>
      <Helmet>
        <title>{pageTitles.termsOfUse}</title>
      </Helmet>
      <HeroSection
        image={pageContent.HERO_SECTION.heroImage}
        title={pageContent.HERO_SECTION.pageHeading}
        text={pageContent.HERO_SECTION.pageSummary}
      />
      <InfoContent content={pageContent.CONTENT} />
    </Layout>
  )
}

export default TermsOfUsePage
